import debounce from 'lodash.debounce';

export default class AdviceNotice {
  constructor() {
    this.isRendered = false;
    const { htDealInfo, isOpenNow } = TMON.htStaticData;
    if (htDealInfo.statusType === "AV" && isOpenNow) {
      if (TMON.sDevice === 'PW') {
        this.render();
      } else {
        this.setEvent();
      }
    }
  }

  update(sStorageKey) {
    if (sStorageKey === 'purchaseDrawer') {
      if (!this.isRendered) return;

      const welAdviceNotice = $('.deal-induce');
      if (TMON.oApp.htStorage.purchaseDrawer === 'close' && window.scrollY !== 0) {
        welAdviceNotice.show();
      } else {
        welAdviceNotice.hide();
      }
    }
  }

  render() {
    const { isViewAdviceDeal, viewAdviceDealPvCount } = TMON.htStaticData;
    const { dealMax } = TMON.htStaticData.htDealInfo;
    const { data: reviewData } = TMON.oApp.htStorage.representativeReview;

    if (!dealMax || dealMax.soldOut) return;
    let swiperHtml = ``;
    if (isViewAdviceDeal) {
      swiperHtml += `<div class="swiper-slide" style="height: 42px;"><p><i class="watch"></i>지금 이 상품을 <strong>${TMON.util.numberFormat(
        viewAdviceDealPvCount
      )}명</strong>이 보고 있어요!</p></div>`;
    }
    if (dealMax.buyCount >= 50) {
      swiperHtml += `<div class="swiper-slide" style="height: 42px;"><p><i class="buy"></i>지금까지 <strong>${TMON.util.numberFormat(
        dealMax.buyCount
      )}명</strong>이 구매하고 있어요</p></div>`
    }
    if (dealMax.buyCount >= 10 && dealMax.stockCount < 100 && dealMax.stockCount > 0) {
      swiperHtml += `<div class="swiper-slide" style="height: 42px;"><p><i class="burn"></i>비상! 상품이 빠르게 소진중이에요!</p></div>`;
    }
    if (
      reviewData &&
      reviewData.reviewAvgScore >= 4.5 &&
      reviewData.reviewCount >= 10
    ) {
      swiperHtml += `<div class="swiper-slide" style="height: 42px;"><p><i class="wow"></i>와우, <strong>${TMON.util.numberFormat(
        reviewData.reviewCount
      )}명</strong>이 구매 후 대만족한 상품이에요</p></div>`;
    }

    if (!swiperHtml) return;

    const html = `<div class="deal-induce">
        <div class="swiper-wrapper">${swiperHtml}</div>
      </div>`;
    
    if (TMON.sDevice === "PW") {
      $('.order_btn').prepend(html);
      $('.deals_floating_opt #_timeSchSide').before(html);
    } else {
      $('#prch-wrap').before(html);
      $('body').addClass('hot_deals');
    }
    this.isRendered = true;

    this.oSwiper = new Swiper(".deal-induce", {
      loop: $('.deal-induce').eq(0).find('.swiper-slide').length > 1,
      direction: "vertical",
      allowTouchMove: false,
      autoplay: {
        delay: 3000
      }
    });
  }

  setEvent() {
    $(window).on('scroll', $.proxy(this.handleScroll, this));
  }

  clearEvent() {
    $(window).off('scroll', $.proxy(this.handleScroll, this));
  }

  handleScroll = debounce(() => {
    if (!this.isRendered) {
      this.render();
      return;
    }
    const welAdviceNotice = $('.deal-induce');
    if (window.scrollY !== 0) {
      welAdviceNotice.show();
    } else {
      welAdviceNotice.hide();
    }
  }, 10);
}